export default __webpack_public_path__ + "static/media/ios-diagram.44f61e12.png";